/**
 * 카테고리 리스트 페이지네이션 모델
 * @type {{totalCnt: null, pageSize: number, pageNum: number}}
 */
export const CATEGORY_LIST_PAGINATION_MODEL = {
  pageSize: 50,
  pageNum: 0,
  totalCnt: null,
};

/**
 * 카테고리 리스트 필터 옵션 모델
 * @type {{sortType: null, exposureType: null, name: null, isExhibit: null, id: null, type: null, status: null}}
 */
export const CATEGORY_LIST_FILTER_OPTION_MODEL = {
  // 카테고리 고유 ID
  id: null,
  // 카테고리 명
  name: null,
  // 카테고리 종류
  type: null,
  // 카테고리 상태
  status: null,
  // 전시 여부
  isExhibit: null,
  // 노출 타입
  exposureType: null,
  // 정렬 타입
  sortType: null,
  // 카테고리 차수
  degree: 1,
};

/**
 * 카테고리 상품 리스트 필터 옵션 모델
 * @type {{name: null, orderBy: string, storeName: null, sortBy: string, id: null, storeId: null, storeStatus: null, status: null}}
 */
export const CATEGORY_PRODUCT_LIST_FILTER_OPTION_MODEL = {
  // 브랜드 명
  brandName: null,
  // 브랜드 ID
  brandId: null,
  // 브랜드 상태
  brandStatus: null,
  // 상품 ID
  id: null,
  // 상품 명
  name: null,
  // 판매 상태
  status: null,
  // 정렬 기준
  sort: [],
};
